export default __webpack_public_path__ + "static/media/incoming-message.bea13ef9.svg";